import React from 'react';
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    // 🌟 YAHAN SIRF ADMIN KA TOKEN CHECK HOGA
    const token = localStorage.getItem("admin_token");

    if (!token) {
        console.warn("🔒 Admin access blocked, redirecting to login. Current path:", window.location.pathname);
        return <Navigate to="/admin/login" replace />;
    }

    return children;
}